import { CoreDomainSearchModule } from '@wix/core-domain-search';
export const CoreDomainSearchStore = CoreDomainSearchModule.SDK.domainInputStore;
export { CoreDomainSearchBaseLayout } from '@wix/core-domain-search';
export * from './module/domainSearchSuite.module';
export { SearchRecommendationLayout } from './components';
export { AiInsightsModal } from './components';
export { BusinessNameAiInsightsModal } from './components';
export { AiInsightsButton } from './components';
export { SiteSelectorModal } from './components';
export { SiteSelectorPage } from './components';
export { TldsSheet } from './components';
export { TldAlternatives, TldAlternativeCard, TldAlternativesSkeleton } from './components';
export { PremiumDomainBadge } from './components';
export { FreeDomainBadge } from './components/FreeDomainBadge/FreeDomainBadge';
export { PricingSection } from './components';
export { PricingContent } from './components';
export { TldPromotionPrice } from './components/TldPromotions/TldPromotion/TldPromotionContent';
export { SearchRecommendationModule } from './components/SearchRecommendation/SearchRecommendation.module';
export { DomainWithEllipsis } from './components/DomainWithEllipsis';
export { DomainText } from './components/DomainText';
export { ComBrRestriction } from './components/SearchRecommendation/ComBrRestriction';
export { isInteractiveClickTarget } from './components/SearchRecommendation/utils';
export { EntriIntroModalModule, EntriModule, ModalsModule } from './module/extensions';
export { EntriIntroModalBody, EntriIntroModalFooter } from './module/extensions/ModalsExtensions/Modals/SharedModals/EntriModal/EntriIntroModal/EntriIntroModal';
export { waitForEntriIframeReady } from './module/extensions/ModalsExtensions/Modals/SharedModals/EntriModal';
export { CONTAINER_ID as ENTRI_FULL_PAGE_CONTAINER_ID, mountEntriContainer, unmountEntriContainer } from './module/extensions/ModalsExtensions/Modals/SharedModals/EntriModal/entriFullPageContainer';
export { DomainActionsErrorsMap } from './module/extensions/types';
export { LOGGER_DOMAINS_SEARCH_SUITE_ENTITY } from './constants';
export { useUiConfig } from './module/extensions/Actions/context';
export { DomainSearchError } from './module/extensions/types';
export { Statuses, StatusesModule } from './module/extensions/Actions/components';
export { useGoogleCustomerCheck } from './module/hooks/useGoogleCustomerCheck';
export { useGoogleRestrictedWordCheck } from './module/hooks/useGoogleRestrictedWordCheck';
//# sourceMappingURL=index.js.map